import { Component, useEffect, useState, useMemo, useRef } from "react";
import { useLocation } from "react-router";
import { useTranslation, withTranslation } from "react-i18next";
import { RestAPI } from "@aws-amplify/api-rest";
import { withFormik, Form } from "formik";

import { GoogleMapsFarm } from "../../components/GoogleMapsFarm/GoogleMapsFarm";
import { callSend, FormRow, HeaderButtons, Vinculos } from "../../components/Form/Form";
import LoadingDialog from "../../components/Utils/LoadingDialog";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatPortsData } from "../../../src/components/Node/Node";
import withName from "../../hoc/withName";
import "react-toastify/dist/ReactToastify.css";
import { connections } from "../Farms/Farms";
import Loading from "../../img/loading-borde-suave.gif";
import SelfHelp from "../../components/Utils/SelfHelp";
import { dateFormat } from "../../utils/date";
import records from "../../utils/records";
import { FarmsTable, RecordsTable } from "./Tables";
import { GeneratorExcel } from "../../utils/GenerateExcel";
import ButtonPrime from "../../components/PrimeComponents/ButtonPrime";
import TooltipPrime from "../../components/PrimeComponents/TooltipPrime";
import CalendarPrime from "../../components/PrimeComponents/CalendarPrime";
import { isInDateRange } from "../../utils/DataUtils";

const account = "account_form";

const getParams = (location) => {
    if (location.search.search("account") !== -1) {
        const params = new URLSearchParams(location && location.search);
        const account = params.get("account");
        return account;
    } else {
        return null;
    }
};

async function getUserRecords(farmId) {
    try {
        const param = `/users/${farmId}`;
        const result = await RestAPI.get("apiAdminDropControl", param);
        return result;
    } catch (error) {
        console.log("error", error);
        return [];
    }
}

class AccountForm extends Component {
    render() {
        const { resetForm, status = {}, setStatus, data, t, i18n, handleSubmit, redirDC } = this.props;
        if (!data) return <div className="container-fluid font13">No Data</div>;
        const canEdit = data && data.can_edit;
        const isEdit = canEdit && status.edit;
        const SelfHelpFarminfo1 = import.meta.glob("../../img/autoayuda/*/autoayuda-account-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-account-1.png`];
        const SelfHelpFarminfo2 = import.meta.glob("../../img/autoayuda/*/autoayuda-account-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-account-2.png`];

        return (
            <>
                <div className="card">
                    <div className="card-body altura-min">
                        <Form id={account} onSubmit={handleSubmit}>
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-3'>
                                    <SelfHelp t={t} params={null} images={[SelfHelpFarminfo1, SelfHelpFarminfo2]} lng={i18n.language} />
                                </div>
                                <div className='col col-sm-8 col-md-6 col-lg-6 text-center'>
                                    <h5 className="card-title">
                                        <span>{t("accounts.accInfo")}</span>
                                    </h5>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-3 d-flex justify-content-end align-items-center'>
                                    <HeaderButtons edit={status.edit} canEdit={canEdit} setStatus={setStatus} resetForm={resetForm} form={account} />
                                </div>
                            </div>
                            <div className='linea-titulo' />
                            <div className='row'>
                                <div className='col-12 text-center'>

                                    <FormRow
                                        /* edit={isEdit} */
                                        dato1={data.razon_social}
                                        nombre1={t("farms.farmTable.razonSocial")}
                                        campo1="razon_social"
                                    />
                                    <FormRow
                                        edit={isEdit}
                                        dato1={data.nombre_representante_legal}
                                        nombre1={t("accounts.nombreRepLegal")}
                                        campo1="nombre_representante_legal"
                                    />
                                    <FormRow
                                        edit={isEdit}
                                        dato1={data.email} dato2={data.telefono}
                                        nombre1={t("accounts.emailContact")} nombre2={t("accounts.phoneContact")}
                                        campo1="email" campo2="telefono"
                                    />

                                    {data.fecha_creacion &&
                    <FormRow
                        dato1={data.fecha_creacion === "" || data.fecha_creacion === null ? null : dateFormat(data.fecha_creacion, t, i18n.language, null, true)}
                        nombre1={t("farms.fechaCreacion")}
                        campo1="fecha_creacion"
                    />}

                                    <Vinculos accountDC={redirDC} />
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </>
        );
    }
}

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        return {
            razon_social: props.data.razon_social,
            nombre_representante_legal: props.data.nombre_representante_legal,
            email: props.data.email,
            telefono: props.data.telefono,
            fecha_creacion: props.data.fecha_creacion
        };
    },
    enableReinitialize: true,
    handleSubmit: (values, { props, ...actions }) => {
        props.updateData(values, props);
        actions.setStatus({
            edit: false,
        });
    }
})(withTranslation()(AccountForm));

const processDataFarm = (accountData, fields, t, i18n) => {
    accountData.forEach((farm) => {
        const idCampo = farm.campo_id;
        const husoHorario = farm.huso_horario;
        const nodos = farm.nodos;

        fields.forEach((field) => {
            const idField = field.id.split("-")[1];
            if (idField == idCampo) {
                field.huso_horario = husoHorario;
                field.nodos = nodos;
                field.cantidad = 0;
                if (!nodos) return;

                nodos.forEach((nodo) => {
                    if (!nodo) return;
                    if (!nodo.is_external) {
                        const portsData = formatPortsData(nodo);
                        nodo.ports = portsData;
                        delete nodo.puertos_tarjetas_expansion;
                        const jerarquia = nodo.ports.hierarchy;
                        const dataNodos = connections(jerarquia)[0];
                        nodo.data = dataNodos;
                        const cantidadSensores = dataNodos.tipoActuador.reduce((total, sensor) => {
                            return total + sensor.cantidad;
                        }, 0);
                        const cantidadActuadores = dataNodos.tipoSensor.reduce((total, sensor) => {
                            return total + sensor.cantidad;
                        }, 0);
                        nodo.cantidad = cantidadSensores + cantidadActuadores;
                        field.cantidad += nodo.cantidad;
                    }
                });
            }
        });
    });
};


const Account = ({ fields, mapRef }) => {
    const location = useLocation();
    const [info, setInfo] = useState({ data: [], isLoaded: false, adminUsers: [] });
    const accountId = getParams(location);
    const { t, i18n } = useTranslation();
    const redirDC = `https://www.dropcontrol.com/site/dashboard/resumen.do?cuentaId=${accountId}`;

    const [arrUsersRecords, setArrUsersRecords] = useState([]);
    const [showValidation, setShowValidation] = useState(false);
    const [showValidation3M, setShowValidation3M] = useState(false);
    const [calendarLoading, setCalendarLoading] = useState(false);
    const [usersInfo, setUsersInfo] = useState([]);
    const today = new Date();
    const lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6);
    const [firstExec, setFirstExec] = useState(true);
    const [firstUserExec, setFirstUserExec] = useState(true);
    const [showFarms, setShowFarms] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rangeDates, setRangeDates] = useState(null);
    const dataAccountRef = useRef(null);

    useEffect(() => {
        setInfo((state) => {
            return { ...state, isLoaded: false };
        });
        if (account !== null && fields) {
            const param = `/accounts/${accountId}`;
            const usersParam = `/users/${accountId}/admin`;
            const accountFarmsParam = `/accounts/${accountId}/farms`;

            const getDatos = async () => {
                try {
                    const data = await RestAPI.get("apiAdminDropControl", param);
                    dataAccountRef.current = data;
                    setInfo({
                        users: [],
                        isLoaded: true,
                        data: data
                    });
                    const adminUsers = await RestAPI.get("apiAdminDropControl", usersParam);
                    setInfo((state) => {
                        return { ...state, users: adminUsers };
                    });
                    const accountData = await RestAPI.get("apiAdminDropControl", accountFarmsParam);
                    processDataFarm(accountData, fields, t, i18n);
                    setLoading(true);
                }
                catch (err) {
                    console.error("error", err);
                }
            };
            getDatos();
        }
    }, [accountId, fields]);

    const noFarmsData = !Array.isArray(fields);
    const tooltipVisible = noFarmsData || !fields.some(campo => campo.latitud && campo.longitud);

    const newFields = useMemo(() => {
        if (Array.isArray(fields) && fields.length > 0) {
            return fields.map(d => {
                if (info.users && info.users.length > 0) {
                    const userObj = info.users.find(u => u.campo_id == d.id.split("-")[1]);
                    d.administradores = userObj ? userObj.users : null;
                }
                return d;
            });
        }
        return [];
    }, [info, fields]);

    const farmIds = newFields.map(farm => {
        return parseInt(farm.id.split("-")[1]);
    });

    useEffect(() => {
        if(firstUserExec && farmIds && farmIds.length) {
            let tempUsersInfo = [];
            const promises = farmIds.map(farmId => getUserRecords(farmId).then(res => {
                res.users?.forEach(user => {
                    user.farmId = farmId;
                });
                return res.users || [];
            }));
            Promise.all(promises).then(array_result => {
                array_result.forEach(arr => {
                    tempUsersInfo = [...tempUsersInfo, ...arr];
                });
                setUsersInfo(tempUsersInfo);
            });
            setFirstUserExec(false);
        }
    }, [farmIds, usersInfo]);

    useEffect(() => {
        if(firstExec){
            if(!rangeDates){
                setRangeDates([lastWeek,today]);
            }
            if(farmIds.length && usersInfo.length){
                let tempUsersRecords = [];
                farmIds.forEach((farmId) => {
                    const farmUsers = usersInfo.filter(user => {
                        if(user.farmId === farmId) return user;
                        return null;
                    });

                    if (farmUsers) {
                        const lng = i18n.language;
                        if (farmUsers.length) {
                            setCalendarLoading(true);
                            const promise_result = records(farmUsers, lastWeek, today, lng, farmId, newFields);
                            promise_result.then(arr => {
                                tempUsersRecords = [...tempUsersRecords, ...arr];
                                setArrUsersRecords(tempUsersRecords);
                            });
                        }
                    }
                });
                setFirstExec(false);
            }
        }

        if (usersInfo && arrUsersRecords.length === usersInfo.length) setTimeout(() => { setCalendarLoading(false); }, 200);
    }, [i18n.language, rangeDates, farmIds, usersInfo, arrUsersRecords]);

    const selfHelpImgDes1 = import.meta.glob("../../img/autoayuda/*/autoayuda-usersRecords-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-usersRecords-1.png`];
    const selfHelpImgDes2 = import.meta.glob("../../img/autoayuda/*/autoayuda-usersRecords-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-usersRecords-2.png`];
    const selfHelpImgDes3 = import.meta.glob("../../img/autoayuda/*/autoayuda-usersRecords-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-usersRecords-3.png`];
    const selfHelpImgDes4 = import.meta.glob("../../img/autoayuda/*/autoayuda-usersRecords-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-usersRecords-4.png`];

    const selfHelpTabla = [
        {
            tab: 1, header: { text: t("selfHelp.instructions") }, params:
        [
            { id: 1, text: t("selfHelp.usersRecords.msg1"), image: selfHelpImgDes1 },
            { id: 2, text: t("selfHelp.usersRecords.msg2"), image: selfHelpImgDes2 },
            { id: 3, text: t("selfHelp.usersRecords.msg3"), image: selfHelpImgDes3 },
            { id: 4, text: t("selfHelp.usersRecords.msg4"), image: selfHelpImgDes4 },
        ]
        },
        {
            tab: 2, header: { text: t("selfHelp.definitionsHeader") }, definition: true, params:
        [
            { id: 1, defName: "DropControl: ", defText: t("selfHelp.definitions.dias_dc") },
            { id: 2, defName: "DropControl APP: ", defText: t("selfHelp.definitions.dias_dc_app") },
            { id: 2, defName: `${t("forms.riegosProgramados")}: `, defText: t("selfHelp.definitions.cant_riegos") },
            { id: 2, defName: `${t("forms.comentariosRealizados")}: `, defText: t("selfHelp.definitions.cant_comentarios") }
        ],
        }
    ];
    return (
        <div className='row-container'>
            {!info.isLoaded && noFarmsData && <LoadingDialog />}
            <div className='row'>
                <div className="col-xl-6 col-lg-12 col-sm-12" >
                    <FormikForm
                        data={info.data} isLoaded={info.isLoaded}
                        updateData={
                            (newData) => callSend(`/accounts/${info.data.cuenta_id}`, info.data, newData, t, (data) => setInfo(prev =>{
                                const updatedData = {...prev.data, ...newData};
                                return {...prev, data:updatedData};
                            }))
                        }
                        redirDC={redirDC}
                        i18n={i18n}
                    />
                </div>

                <div className="col-xl-6 col-lg-12 col-sm-12 map-col">
                    <div className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4' />
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title">
                                        <span>{t("maps.map")}</span>
                                        {tooltipVisible ?
                                            <TooltipPrime id="account-map-nodata"  content={t("maps.nodata")} position="bottom" >
                                                <FontAwesomeIcon size="lg" icon={faInfoCircle} style={{ color: "tomato", fontSize:"1.25rem" }} />
                                            </TooltipPrime>
                                            : null}
                                    </h5>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center' />
                            </div>
                            <div className='linea-titulo' />
                            <div className='mapsWrapper'>
                                {!tooltipVisible &&
                  <GoogleMapsFarm
                      apiKey="AIzaSyCvs7xPDh2vfmQO2w02lcItOXa6OKOVmQ4"
                      data={fields}
                      accountId={accountId}
                      innerRef={mapRef}
                      language={i18n.language}
                  />}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 col-lg-12">
                    <div className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4' />
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title">
                                        <span>{`${t("farms.farms")} (${(Array.isArray(newFields) && newFields.length) || 0})`}</span>
                                    </h5>
                                </div>
                                <div id="farmsTableToolbar" className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'>
                                    { loading && <GeneratorExcel data={newFields} t={t} i18n={i18n} dataAccountRef={dataAccountRef.current} /> }
                                </div>
                            </div>
                            <div className='linea-titulo' />
                            {(Array.isArray(newFields) && newFields.length > 0) ?
                                (loading ?
                                    <FarmsTable fields={newFields} t={t} i18n={i18n} />
                                    :
                                    <div className='row-container'><img className='img-loading' src={Loading} alt="Loading..." /></div>
                                )
                                :
                                <span className='no-data'>{t("forms.noData")}</span>}
                        </div>
                    </div>

                    <div className="card" id='cardUsersAccess'>
                        {calendarLoading && <LoadingDialog appendTo="self" />}
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4'>
                                    {selfHelpTabla &&
                    <SelfHelp t={t} lng={i18n.language} params={selfHelpTabla} fertiTable />}
                                </div>
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title"><span>{t("forms.registros")}</span></h5>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center' />
                            </div>
                            <div className='linea-titulo' />
                            <div className='row'>
                                <div className="col-12 col-md-6 text-md-right mtem-05">
                                    <label className="boldie">{t("forms.rangoFechas")}</label>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                                    <div>
                                        <CalendarPrime
                                            id="daterangepicker"
                                            t={t}
                                            maxDaysRange={90}
                                            setValue={setRangeDates}
                                            value={rangeDates}  onChange={(e) => setRangeDates(e.value)}
                                            locale={i18n.language}
                                            selectionMode="range"
                                            presets
                                        />
                                    </div>
                                </div>
                                {showValidation &&
                  <div className="col-12 msgRawValidation">
                      <span>{t("forms.msgUserAccessValidation")}</span>
                  </div>}
                                {showValidation3M &&
                  <div className="col-12 msgRawValidation">
                      <span>{t("forms.msgValidacionRangoFechas3M")}</span>
                  </div>}
                            </div>

                            <div className="row">
                                <div className='col-4' />
                                <div className='col-4 mb-4 mt-4 text-center'>
                                    <ButtonPrime label={t("forms.search")} onClick={() => {
                                        const desde = rangeDates && Array.isArray(rangeDates) && rangeDates[0];
                                        const hasta = rangeDates && Array.isArray(rangeDates) && rangeDates[1];
                                        if (desde && hasta) {
                                            if(isInDateRange(desde,hasta,91)){
                                                setShowValidation3M(true);
                                                setShowValidation(false);
                                            }else{
                                                setArrUsersRecords([]);
                                                !calendarLoading && setCalendarLoading(true);
                                                if (usersInfo.length) {
                                                    let tempUsersRecords = [];
                                                    farmIds.forEach(farmId => {
                                                        const farmUsers = usersInfo.filter(user => {
                                                            if(user.farmId === farmId) return user;
                                                            return null;
                                                        });
                                                        if (farmUsers && farmUsers.length) {
                                                            const promise_result = records(farmUsers, desde, hasta, i18n.language, farmId, newFields);
                                                            promise_result.then(arr => {
                                                                tempUsersRecords = [...tempUsersRecords, ...arr];
                                                                setArrUsersRecords(tempUsersRecords);
                                                            });
                                                        }
                                                    });
                                                    setShowValidation3M(false);
                                                    setShowValidation(false);
                                                }
                                            }
                                        } else {
                                            if (!rangeDates?.[1] || !rangeDates?.[0]) {
                                                setShowValidation(true);
                                                setShowValidation3M(false);
                                            }
                                        }
                                    }}
                                    />
                                </div>
                                <div className='col-4 mb-4 mt-4 text-right'>

                                    <ButtonPrime label={showFarms ? t("forms.tableByUser") : t("forms.tableByField")} onClick={() => {
                                        !calendarLoading && setCalendarLoading(true);
                                        setShowFarms(!showFarms);
                                    }}
                                    />
                                </div>
                            </div>
                            <RecordsTable usersData={arrUsersRecords} t={t} lng={i18n.language} fields={showFarms} />
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
};

export default withName(Account, "AccountPage");
